import { IoSend } from "react-icons/io5";
import { Paperclip, Smile } from "lucide-react";
import { InputText } from "primereact/inputtext";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sendMessage } from "../state/chat_slice";
import { chatActions } from "../../../di/di";
import { useState, useRef } from "react";

const ChatFooterComponent = () => {
  const dispatch = useDispatch();
  const message = useSelector((state) => state.chat.enteredMessage);
  const hasPendingMessageProcess = useSelector((state) => state.chat.hasPendingMessageProcess);
  const [selectedImages, setSelectedImages] = useState([]);
  const fileInputRef = useRef(null);

  const setMessage = (e) => {
    dispatch(chatActions.setEnteredMessage(e.target.value));
  };

  const handleSendPressed = () => {
    if ((message.trim() !== "" || selectedImages.length > 0) && !hasPendingMessageProcess) {
      // Show subscription modal instead of sending the message
      //dispatch(chatActions.setShowSubscriptionModal(true));
      dispatch(chatActions.messageSend());
      setSelectedImages([]);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSendPressed();
    }
  };

  const handleAttachmentClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    files.forEach((file) => {
      if (file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = (e) => {
          setSelectedImages((prev) => [...prev, e.target.result]);
        };
        reader.readAsDataURL(file);
      }
    });

    // Reset file input
    e.target.value = null;
  };

  const removeImage = (index) => {
    setSelectedImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleEmojiClick = () => {
    // Emoji picker functionality can be implemented here
    console.log("Emoji picker clicked");
  };

  return (
    <div className="h-[5.2rem] border-t border-red-900/20 backdrop-blur-md pt-4 px-4">
      {selectedImages.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-3">
          {selectedImages.map((image, index) => (
            <div key={index} className="relative h-16 w-16 rounded-md overflow-hidden">
              <img src={image} alt="Selected" className="h-full w-full object-cover" />
              <button
                className="absolute top-0 right-0 bg-red-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs hover:bg-red-700"
                onClick={() => removeImage(index)}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="max-w-5xl mx-auto">
        <div className="relative">
          <input
            type="text"
            placeholder="Type your message..."
            value={message}
            onChange={setMessage}
            onKeyPress={handleKeyPress}
            autoComplete="new-password"
            className="w-full 
            text-base 
            px-4 py-3 
            pl-4 pr-11
            rounded-xl 
            bg-gray-800/60 
            text-white 
            placeholder-white-50 
            outline-none 
            shadow-inner 
            border border-white/10 
            transition-all
            focus:border-red-900/40
            focus:ring-2
            focus:ring-red-900/20"
          />

          <button
            onClick={handleSendPressed}
            disabled={hasPendingMessageProcess || !message.trim()}
            className="rounded-xl absolute right-[5px] top-[5px] w-10 h-10 bg-gradient-to-r from-red-700 to-red-900 flex items-center justify-center shadow-lg hover:opacity-90 transition-all hover:shadow-red-500/20 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed active:translate-y-0.5 active:shadow-none"
          >
            <IoSend size={18} className="text-white" />
          </button>

          <div className="absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center space-x-1">
            {/* <button
              onClick={handleAttachmentClick}
              className="w-8 h-8 rounded-full bg-slate-700/50 flex items-center justify-center hover:bg-slate-600/60 transition-colors"
            >
              <Paperclip size={16} className="text-pink-200" />
            </button>

            <button
              onClick={handleEmojiClick}
              className="w-8 h-8 rounded-full bg-slate-700/50 flex items-center justify-center hover:bg-slate-600/60 transition-colors"
            >
              <Smile size={16} className="text-pink-200" />
            </button> */}
          </div>

          <input type="file" ref={fileInputRef} onChange={handleFileChange} accept="image/*" multiple className="hidden" />
        </div>
      </div>
    </div>
  );
};

export default ChatFooterComponent;
